export type BadgeType =
  | 'class'
  | 'constructor'
  | 'static-method'
  | 'instance-method'
  | 'global-method'
  | 'static-field'
  | 'instance-field'
  | 'global-field'
  | 'default'

export const getBadgeType = (badge?: string): BadgeType => {
  if (!badge) {
    return 'default'
  }

  const normalized = badge.trim().toLowerCase()

  if (normalized === 'class' || normalized === 'type_def' || normalized === 'type def') return 'class'
  if (normalized === 'constructor') return 'constructor'
  if (normalized === 'static method') return 'static-method'
  if (normalized === 'instance method') return 'instance-method'
  if (normalized === 'global method') return 'global-method'
  if (normalized === 'static field') return 'static-field'
  if (normalized === 'instance field') return 'instance-field'
  if (normalized === 'global field') return 'global-field'

  return 'default'
}
